import React from 'react';
import { Apple } from 'lucide-react';
export function AppStoreButton() {
  return <button className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-xl hover:bg-gray-800 transition-colors shadow-md" data-id="element-9">
      <Apple className="w-6 h-6 fill-current" data-id="element-10" />
      <div className="flex flex-col items-start" data-id="element-11">
        <span className="text-[10px] leading-none mb-0.5" data-id="element-12">Download on the</span>
        <span className="text-sm font-semibold leading-tight" data-id="element-13">App Store</span>
      </div>
    </button>;
}